import styled, { css } from "styled-components";
import {
  BarChart as BaseBarChart,
  LineChart as BaseLineChart,
  BarPlot as BaseBarPlot,
  LinePlot as BaseLinePlot,
} from "@mui/x-charts";
import { colors } from "utils/theme";

const CHART_ATTRS = {
  resolveSizeBeforeRender: true,
};

const CHART_STYLES = css`
  .MuiMarkElement-root {
    display: none;
  }

  .MuiChartsAxis-line,
  .MuiChartsAxis-tick {
    stroke: ${colors.sky};
  }

  .MuiChartsAxis-tickLabel {
    fill: ${colors.dust};
  }
`;

export const LineChart = styled(BaseLineChart).attrs(() => ({
  ...CHART_ATTRS,
}))`
  ${CHART_STYLES}
`;

export const BarChart = styled(BaseBarChart).attrs(() => ({
  ...CHART_ATTRS,
  borderRadius: 4,
}))`
  ${CHART_STYLES}
`;

export const LinePlot = styled(BaseLinePlot)`
  ${CHART_STYLES}
`;

export const BarPlot = styled(BaseBarPlot).attrs(() => ({
  borderRadius: 4,
}))`
  ${CHART_STYLES}
`;
